var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneFill28(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.11 8.344l-1.226-1.26A.264.264 0 0021.689 7a.253.253 0 00-.195.084L9.995 18.644l-4.281-4.281a.275.275 0 00-.195-.084c-.07 0-.14.028-.195.084l-1.24 1.24a.278.278 0 000 .397l5.09 5.09c.25.25.557.397.814.397.37 0 .69-.272.809-.383h.006L23.117 8.74c.097-.118.097-.292-.007-.397z"
  })));
}
export default SvgDoneFill28;